// BIKEJACK Theme - base.js

// Mobile Navigation Toggle
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.nav-mobile-toggle');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      toggle.classList.toggle('is-active');
    });
  }

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (nav) nav.classList.remove('is-open');
      }
    });
  });

  // Product image thumbnails
  document.querySelectorAll('.product-images__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const main = document.querySelector('.product-images__main img');
      if (main) {
        main.src = this.querySelector('img').src;
        document.querySelectorAll('.product-images__thumb').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  // Cart quantity buttons
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (this.dataset.action === 'plus') val = val + 1;
      input.value = val;
    });
  });
});
